import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

import { PredictionsResponseOutputItemsItem } from '@/api/generated';
import { PackShot } from '@/components/blocks/shelf-detail/shelf-detail-sku/pack-shot';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface SkuPredictionListItemProps {
  confirmedSkuMetadataId?: string;
  skuPrediction: PredictionsResponseOutputItemsItem;
  onClick: (skuMetadataId: string) => void;
  className?: string;
}

export const SkuPredictionOverviewCard: FC<SkuPredictionListItemProps> = ({
  confirmedSkuMetadataId,
  skuPrediction,
  onClick,
  className,
}: SkuPredictionListItemProps) => {
  const { t } = useTranslation();
  const isConfirmed = confirmedSkuMetadataId === skuPrediction.skuMetadataId;

  return (
    <Card
      role='button'
      className={cn(
        'relative overflow-hidden hover:cursor-pointer justify-between hover:border-[#FF6738]',
        { 'bg-accent': isConfirmed },
        className
      )}
      onClick={() => {
        onClick(skuPrediction.skuMetadataId);
      }}>
      <CardContent className={'flex-1 size-full'}>
        <PackShot
          imagePath={skuPrediction.imagePath}
          alt={t('shelfDetail.packShotMissing')}
          className={'size-full'}
        />
      </CardContent>
      {isConfirmed && (
        <Badge
          className='absolute bottom-1 left-1'
          variant='annotated'
          aria-hidden>
          <Check className='text-success size-2' />
        </Badge>
      )}
    </Card>
  );
};
